export default __webpack_public_path__ + "static/media/postgress.2d56229f.png";